import axios from 'axios';
import apiBaseUrl from './api-base';
import { getCsrfToken } from './csrf';

const instance = axios.create({ baseURL: apiBaseUrl });
const getToken = () => localStorage.getItem('token');

instance.interceptors.request.use((config) => {
	const nextConfig = { ...config };
	nextConfig.headers = nextConfig.headers || {};

	const token = getToken();
	if (token) nextConfig.headers.Authorization = token;

	const csrfToken = getCsrfToken();
	if (csrfToken) nextConfig.headers['x-csrf-token'] = csrfToken;

	return nextConfig;
});

const normalizeError = (response, fallbackMessage = 'Request failed') => {
	if (!response) return fallbackMessage;
	const { data } = response;
	if (!data) return fallbackMessage;

	if (typeof data === 'string') return data;
	if (typeof data === 'object') return data.message || data.statusMessage || fallbackMessage;
	return fallbackMessage;
};

instance.interceptors.response.use(
	({ data }) => data,
	(error) => {
		const response = error?.response;
		return Promise.reject(normalizeError(response, error?.message));
	},
);

export default instance;
